// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const timelyIntegrationCloudV1UserAccountsSchema = z.object({
  timely_user: z.object({
    id: z.number().int(),
    name: z.coerce.string().min(1),
    avatar_url: z.coerce.string(),
    email: z.coerce.string(),
    tic_id: z.coerce.string().nullish(),
    origin_tic_identity_id: z.coerce.string().nullish(),
  }),
  timely_accounts: z.array(z.object({
    id: z.number().int(),
    title: z.coerce.string().min(1),
    role: z.enum(["admin", "manager", "employee", "team_lead"]),
    logo_url: z.coerce.string(),
    account_owner_user_id: z.number().int(),
    account_owner: z.object({
      id: z.number().int(),
      name: z.coerce.string().min(1),
      avatar_url: z.coerce.string(),
      email: z.coerce.string(),
      tic_id: z.coerce.string().nullish(),
      origin_tic_identity_id: z.coerce.string().nullish(),
    }),
  })),
});
